import { WarehouseType } from 'constants/Warehouses/WarehouseType';
import {t} from "i18next";

export const warehouseTypeLabels: any = {
    'external_fbs': 'Внешний',
    'external_fbo': 'Внешний',
    'fbs': 'Мой',
    'public_fbs': 'Внешний',
    'supplier': 'Поставщик',
}

export const parseWarehouseType = (type: WarehouseType): string => t(warehouseTypeLabels[type]);
